import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { SymbolClientAction } from '../symbolClient.action';

type IDependencies = IClientApiDependencySegment;

// Counters come with every list response, so a single-row page is enough
const COUNTERS_REQUEST_LIMIT = 1;

export const loadSymbolClientCountersEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.loadCounters.started),
  switchMap((params) => {
    const { nodeId, serverId, streamId } = params;

    const request$ = serverId !== undefined
      ? dependencies.api.getServerClientSymbolList({ serverId, streamId, limit: COUNTERS_REQUEST_LIMIT, onlyUnmapped: true })
      : nodeId !== undefined
        ? dependencies.api.getNodeClientSymbolList({ nodeId, streamId, limit: COUNTERS_REQUEST_LIMIT, onlyUnmapped: true })
        : undefined;

    if (!request$) {
      return [];
    }

    return request$.pipe(
      mergeMap((response) => {
        const { totalCount, filteredCount, unmappedCount } = response;

        return [
          SymbolClientAction.loadCounters.done({ params, result: { totalCount, filteredCount, unmappedCount } }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolClientAction.loadCounters.failed({ params, error }),
        ];
      }),
    );
  }),
);
